export var hebei = {
  answer: [
    // 答案页和页码页
    {
      // placement_id: '7081815571979057',
      placement_id: '8012540122115511',
      app_id: '1110572946',
      type: 'banner'
    },
    // 书籍列表页
    {
      placement_id: '1052936983463605',
      app_id: '1110572946',
      type: 'native'
    },
    // 更多课本
    {
      placement_id: '8002934973889450',
      app_id: '1110572946',
      type: 'native'
    },
    // 更多数学
    {
      placement_id: '5042536913891516',
      app_id: '1110572946',
      type: 'native'
    },
    // 更多英语
    {
      placement_id: '3092336903398527',
      app_id: '1110572946',
      type: 'native'
    },
    // 更多语文
    {
      placement_id: '8042637973095538',
      app_id: '1110572946',
      type: 'native'
    }
  ]
}
export var shanxi = {
  answer: [
    // 答案页和页码页
    {
      placement_id: '6091816650227662',
      app_id: '1110507727',
      type: 'banner'
    },
    // 书籍列表页
    {
      placement_id: '4022133915898331',
      app_id: '1110507727',
      type: 'native'
    },
    // 更多课本
    {
      placement_id: '4092031995895336',
      app_id: '1110507727',
      type: 'native'
    },
    // 更多数学
    {
      placement_id: '9062432985791317',
      app_id: '1110507727',
      type: 'native'
    },
    // 更多英语
    {
      placement_id: '1092430965792431',
      app_id: '1110507727',
      type: 'native'
    },
    // 更多语文
    {
      placement_id: '5042530975396476',
      app_id: '1110507727',
      type: 'native'
    }
  ]
}
